import React from 'react';
import { inject, observer } from 'mobx-react';

import InputAreaFirstLoad from '@/components/InputArea/firstLoad';
import { applyChatbotConfig } from '@/config';
import { FirstInitStore } from '@/stores/firstInit';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { isShowInputAreaSkeleton } from '@/utils/firstScreenSkeletonControl';
import { InputAreaSkeleton } from '@/components/Skeleton';

type Props = {
  firstInit: FirstInitStore
}

const Input = (props: Props) => {
  const { firstInit: { initStore, canShowShortcut, showShortcutsSkeleton, canShowInputArea }} = props;
  const { shouldBottomBarHidden } = initStore;

  const { enable } = applyChatbotConfig('inputArea', props) as {
    enable: boolean;
  };

  if (!enable) {
    return null;
  }


  const realShortcutElement = <InputAreaFirstLoad />;
  let renderShortcutElement = null;

  if (isShowInputAreaSkeleton() && !canShowInputArea) {
    if (canShowShortcut) {
      renderShortcutElement = showShortcutsSkeleton ? (
        <InputAreaSkeleton />
      ) : realShortcutElement;
    }
  } else {
    renderShortcutElement = realShortcutElement;
  }

  return !shouldBottomBarHidden
    ? renderShortcutElement
    : null;
};

export default inject(getChildInject('firstInit'))(observer(Input as React.FC<{}>));
